import { axiosCustom } from "../axios/axios";
import { BASE_URL } from "../constants";

class DropdownsService {
  getPropertyTypes() {
    return axiosCustom
      .get(BASE_URL + "settings/property-types")
      .then(response => response.data?.items || []);
  }

  getPropertySubTypes() {
    return axiosCustom
      .get(BASE_URL + "settings/property-sub-types")
      .then(response => response.data?.items || []);
  }
}

export default new DropdownsService();
